import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly _showHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private readonly _reloadMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private readonly _showMsgSessaoExpirada: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  reloadMenu() {
    this._reloadMenu.next(true);
  }

  get reloadMenu$() {
    return this._reloadMenu;
  }

  get showHeader(): boolean {
    return this._showHeader.value;
  }

  disableHeader() {
    this._showHeader.next(false);
  }

  enableHeader() {
    this._showHeader.next(true);
  }

  get showMsgSessaoExpirada(): boolean {
    return this._showMsgSessaoExpirada.value;
  }

  disableMsgSessaoExpirada() {
    this._showMsgSessaoExpirada.next(false);
  }

  enableMsgSessaoExpirada() {
    this._showMsgSessaoExpirada.next(true);
  }
  constructor() { }
}
